import { useEffect, useRef } from 'react';

/**
 * Fires `cleanup` once when the component unmounts or the page unloads.
 * Best-effort: a tab crash / hard external navigation may skip it — the backend
 * 24h scheduler is the backstop.
 */
export function useLeaveStepCleanup(cleanup: () => void | Promise<void>): void {
  const cleanupRef = useRef(cleanup);
  cleanupRef.current = cleanup;

  useEffect(() => {
    const onBeforeUnload = () => {
      void cleanupRef.current();
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      void cleanupRef.current();
    };
  }, []);
}
